var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "video"
  }, [_c('video', {
    staticClass: "video-pause",
    attrs: {
      "id": "video",
      "loop": "",
      "controls": "",
      "preload": "auto",
      "poster": '/static/video/bimbi.jpg',
      "title": "Bimbi"
    }
  }, [_c('source', {
    attrs: {
      "src": '/static/video/bimbi.m4v',
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": '/static/video/bimbi.webm',
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": '/static/video/bimbi.ogv',
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video__bear",
    attrs: {
      "id": "bear"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: {
      'video--active': _vm.isActive, video__play: true
    },
    attrs: {
      "id": "play_btn"
    },
    on: {
      "click": function($event) {
        _vm.toggle_active()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow-down-jump"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63618e9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video.vue
// module id = ianz
// module chunks = 1